import WidgetPreview from './WidgetPreview';
export default WidgetPreview;
